<template>
  <div class="infos">
    <NewsItem v-for="(item, index) in data" :key="index" :data="item" />
  </div>
</template>
<script>
import NewsItem from "@/components/NewsItem/index";
export default {
  props: {
    data: {
      type: Array,
      default: () => ({}),
    },
  },
  components: {
    NewsItem,
  },
};
</script>
<style lang="scss" scoped>
.infos {
  display: grid;
  grid-template-columns: repeat(3, 384px);
  gap: 24px;
}
</style>
